export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/f5c29e86d3a5b6f06334d35443df7aba.svg";